import { dateTimeFormat } from '../i18n/dateTimeFormat';

export function convertDateToTimeZone(date: Date | string) {
	return new Date(
		date.toLocaleString(dateTimeFormat.locale, {
			timeZone: dateTimeFormat.timeZone,
		}),
	);
}
